var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84443 1.0899L9.06545 7.60428C9.37461 7.86927 9.37461 8.35509 9.06545 8.62008L1.84443 15.1345C1.38069 15.554 0.629883 15.2449 0.629883 14.6266L0.629883 1.5978C0.629883 0.979484 1.38069 0.670325 1.84443 1.0899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrowicon);
export default __webpack_public_path__ + "static/media/rightarrowicon.7df9a5aa8962b94ef4d49c38b0c9e2e2.svg";
export { ForwardRef as ReactComponent };